// extracted by mini-css-extract-plugin
module.exports = {"sleekDesign":"SleekDesign_sleekDesign__reh90","ef-box":"SleekDesign_ef-box__MPSLG"};